module.exports = __webpack_public_path__ + "img/8.e9e54450.jpg";